import React, { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import NavMenu from './NavMenu';
import { SidebarCollapsedContext } from './SidebarCollapsed';

export default props => {
  const [showMobile, setShowMobile] = useState(false);

  // Shared collapsed state — persisted in localStorage via NavMenu's own effect
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('solarapp-nav-collapsed') === 'true'; }
    catch { return false; }
  });

  return (
    <SidebarCollapsedContext.Provider value={{ collapsed, toggle: () => setCollapsed(c => !c) }}>
      <div className="d-flex" style={{ minHeight: '100vh' }}>
        {/* Mobile Hamburger Button */}
        <button
          className="mobile-hamburger d-sm-none"
          onClick={() => setShowMobile(true)}
          aria-label="Menu open"
        >
          <i className="bi bi-list" />
        </button>

        {/* Desktop Sidebar */}
        <div className={`sidebar-container d-none d-sm-block ${collapsed ? 'collapsed' : ''}`}>
          <NavMenu />
        </div>

        {/* Mobile Offcanvas Sidebar */}
        <Offcanvas show={showMobile} onHide={() => setShowMobile(false)} placement="start">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Navi</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <NavMenu />
          </Offcanvas.Body>
        </Offcanvas>

        {/* Main Content */}
        <div className="flex-grow-1 px-4 py-3 content-area">
          {props.children}
        </div>
      </div>
    </SidebarCollapsedContext.Provider>
  );
};
